import { useNavigate } from 'react-router';
import { useFlowium } from '../client/FlowiumContext';
import { FlashColorIcon, SettingsIcon } from './Icons';

const UpgradeButton = ({
    text,
    className,
    fullWidth = true,
}: {
    text: string;
    className?: string;
    fullWidth?: boolean;
}) => {
    const navigate = useNavigate();
    const { user } = useFlowium();
    const plan = user?.plan?.toLowerCase() || 'free';
    const isPaid = plan !== 'free';

    return (
        <button
            onClick={() => navigate('/settings/plan')}
            className={`inline-flex items-center justify-center gap-2 rounded-xl border border-secondary bg-surface px-3 py-2 text-sm font-medium text-content transition-colors hover:bg-hover ${fullWidth ? 'w-full' : ''} ${className || ''}`}
        >
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent/10 text-accent">
                {isPaid
                    ? <SettingsIcon padding={0} size={4} />
                    : <FlashColorIcon padding={0} size={4} />
                }
            </span>
            <span>{isPaid ? 'Manage Plan' : text}</span>
        </button>
    )
}

export default UpgradeButton;
